import * as React from 'react';
import {render} from 'react-dom';

import {Provider as I18nProvider} from '@pinecast/i18n';
import PlayerPlaylist from '@pinecast/pl-spa/PlayerPlaylist';
import {Provider as StyletronProvider} from '@pinecast/styles/provider';

render(
  <React.StrictMode>
    <I18nProvider>
      <StyletronProvider>
        <PlayerPlaylist />
      </StyletronProvider>
    </I18nProvider>
  </React.StrictMode>,
  document.querySelector('.omnibus'),
);
